import { baseApi } from 'core/api/base'
import { generatePath } from 'react-router'
import { IPrompt, IPromptDetail } from 'core/interfaces/Prompt'
import { APPLICATION_ENDPOINT } from 'core/api/application'

const PROMPTS_ENDPOINT = '/prompts'
const PROMPT_ENDPOINT = `${PROMPTS_ENDPOINT}/:promptId`
const PROMPTS_WITH_DETAILS_ENDPOINT = `${APPLICATION_ENDPOINT}/prompts-details`

const promptApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPromptsWithDetailsFromApplication: builder.query<
      IPromptDetail[],
      { applicationId: number }
    >({
      query: ({ applicationId }) =>
        generatePath(PROMPTS_WITH_DETAILS_ENDPOINT, {
          applicationId: applicationId.toString(),
        }),
    }),
    getPrompt: builder.query<IPrompt, { promptId: number }>({
      query: ({ promptId }) =>
        generatePath(PROMPT_ENDPOINT, {
          promptId: promptId.toString(),
        }),
      providesTags: (result, error, promptId) => [{ type: 'Prompt', promptId }],
    }),
    createUpdatePrompt: builder.mutation<
      IPrompt,
      {
        data: FormData
      }
    >({
      query: ({ data }) => ({
        url: generatePath(PROMPTS_ENDPOINT),
        method: 'POST',
        body: data,
      }),
      invalidatesTags: (result) =>
        result
          ? [
              { type: 'Prompt', id: 'LIST' },
              { type: 'Application', id: result.idApplication },
            ]
          : [{ type: 'Prompt', id: 'LIST' }],
    }),
    deletePrompt: builder.mutation<void, number>({
      query(promptId) {
        return {
          url: generatePath(PROMPT_ENDPOINT, {
            promptId: promptId.toString(),
          }),
          method: 'DELETE',
        }
      },
      invalidatesTags: (result, error, id) => [{ type: 'Prompt', id }],
    }),
  }),
})

export const {
  useGetPromptsWithDetailsFromApplicationQuery,
  useGetPromptQuery,
  useCreateUpdatePromptMutation,
  useDeletePromptMutation,
} = promptApi
export { promptApi }
